import styled from 'styled-components'

export const Wrapper = styled.div`
  border: 1.5px solid var(--vo-steel);
  border-radius: 10px;
  padding: 8px 12px;
  min-height: 40px;
  transition: border-color 0.2s;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
  cursor: text;
  background: white;

  &:focus-within {
    border-color: var(--color-brand);
  }
`

export const Chip = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 10px;
  background: var(--vo-capri-50);
  color: var(--vo-celeste);
  font-family: 'Maven Pro', sans-serif;
  font-size: 12px;
  font-weight: 500;
  border-radius: 20px;
  max-width: 100%;
  overflow: hidden;
`

export const ChipLabel = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const ChipRemoveButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 0;
  line-height: 1;
  color: var(--vo-celeste);
  border-radius: 50%;

  &:hover {
    opacity: 0.7;
  }
`

export const Input = styled.input`
  border: none;
  outline: none;
  font-family: 'Lato', sans-serif;
  font-size: 13px;
  color: var(--vo-ink);
  padding: 4px 0;
  min-width: 60px;
  flex: 1;
  background: transparent;

  &::placeholder {
    color: var(--vo-slate);
  }

  &:disabled {
    cursor: not-allowed;
  }
`
